import { DOWNLOAD_FILETYPES, useFileDownload } from '@britishcouncil/react-common';
import { ButtonGroup, Dropdown, Icon } from 'semantic-ui-react';

type ExportTrigger = () => { unwrap: () => Promise<File> };

type ReportExportButtonProps = {
  disabled: boolean;
  fileName: string;
  generatePdf?: ExportTrigger;
  isPdfLoading?: boolean;
  generateExcel: ExportTrigger;
  isExcelLoading: boolean;
};

export const ReportExportButton = ({
  disabled,
  fileName,
  generatePdf,
  isPdfLoading,
  generateExcel,
  isExcelLoading,
}: ReportExportButtonProps) => {
  const downloadService = useFileDownload();

  const onExportToPdf = async () => {
    if (!generatePdf) return;
    try {
      const file = await generatePdf().unwrap();
      downloadService.download(file, fileName, DOWNLOAD_FILETYPES.pdf);
    } catch (error) {
      console.error(error);
    }
  };

  const onExportToExcel = async () => {
    try {
      const file = await generateExcel().unwrap();
      downloadService.download(file, fileName, DOWNLOAD_FILETYPES.xlsx);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ButtonGroup color="green">
      <Dropdown
        trigger={
          <span>
            <Icon name="file" /> Export as
          </span>
        }
        button
        disabled={disabled}
        loading={(isPdfLoading ?? false) || isExcelLoading}
      >
        <Dropdown.Menu>
          {generatePdf && (
            <Dropdown.Item onClick={onExportToPdf}>
              <Icon name="file" />
              Export as PDF
            </Dropdown.Item>
          )}
          <Dropdown.Item onClick={onExportToExcel}>
            <Icon name="file excel" />
            Export as Excel
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </ButtonGroup>
  );
};
